import { formatCurrency } from "@/components/ui/utils";

/**
 * Formats integer cents in the given ISO currency code as a display string
 * (e.g. 24999, "usd" -> "$249.99"). Thin wrapper over the shared `formatCurrency`
 * so cents-based pricing (respondent types, form payments) gets the same
 * currency-correct, cached formatting as the rest of the app instead of a
 * hand-rolled `$`-only string.
 */
export function formatCentsAsCurrency(cents: number, currency: string): string {
  return formatCurrency(currency.toUpperCase(), cents / 100);
}
